import React, { useState } from 'react';
import { MainService } from '../../_services';
import { FileDropzone } from '../shared';

import { S3Service } from '../../_services';
const s3Service = new S3Service();
// [FORM-DATA] import { MainService } from '../../_services';
const ms = new MainService();

const ACCEPTED_EXTENSIONS = ['.xls', '.xlsx', '.csv'];
const MAX_SIZE_MB = 10;

function getExtension(file) {
    return file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
}

function ImportSummary({ summary }) {
    const { totalLines = 0, updated = 0, notFound = 0, notFoundBarCodes = [] } = summary;

    return (
        <div className="import-summary">
            <div className="import-summary-header">
                <i className="fas fa-check-circle" />
                <span>Import terminé — <strong>{totalLines}</strong> ligne{totalLines > 1 ? 's' : ''} traitée{totalLines > 1 ? 's' : ''}</span>
            </div>

            <div className="import-summary-stats">
                <div className="import-stat import-stat--success">
                    <i className="fas fa-check" />
                    <span className="import-stat-value">{updated}</span>
                    <span className="import-stat-label">mise{updated > 1 ? 's' : ''} à jour</span>
                </div>
                {notFound > 0 && (
                    <div className="import-stat import-stat--warning">
                        <i className="fas fa-exclamation-triangle" />
                        <span className="import-stat-value">{notFound}</span>
                        <span className="import-stat-label">non trouvé{notFound > 1 ? 's' : ''}</span>
                    </div>
                )}
            </div>

            {notFoundBarCodes.length > 0 && (
                <div className="import-summary-barcodes">
                    <span className="section-label">Codes-barres non trouvés</span>
                    <div className="import-barcode-list">
                        {notFoundBarCodes.map((bc) => (
                            <span key={bc} className="import-barcode-tag">{bc}</span>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
}

function ImportActionsCard() {
    const [file, setFile] = useState(null);
    const [filename, setFilename] = useState(null);
    const [uploading, setUploading]     = useState(false);
    const [uploadDone, setUploadDone] = useState(false);
    const [uploadError, setUploadError] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [importing, setImporting] = useState(false);
    const [importSummary, setImportSummary] = useState(null);
    const [importError, setImportError] = useState(null);

    const resetDropzone = () => {
        setFile(null);
        setFilename(null);
        setUploadDone(false);
        setUploadError(null);
        setImportError(null);
    };

    // ─── handleFile — upload en deux étapes via URL présignée S3 ─────────────
    const handleFile = async (selectedFile) => {
        resetDropzone();
        setImportSummary(null);

        const ext = getExtension(selectedFile);
        const uuid = crypto.randomUUID();
        const generatedFilename = `${uuid}-rcg${ext}`;

        setFile(selectedFile);
        setFilename(generatedFilename);
        setUploading(true);

        try {
            const presignedRes = await s3Service.getPresignedUploadUrl(generatedFilename);
            await s3Service.uploadFileToS3(presignedRes.data, selectedFile);
            setUploadDone(true);
        } catch {
            setUploadError("Erreur lors de l'upload. Veuillez réessayer.");
            setFile(null);
            setFilename(null);
        } finally {
            setUploading(false);
        }
    };

    // ─── [FORM-DATA] handleFile — stockage local, envoi direct en form-data ──
    // Remplacer le bloc ci-dessus par ce bloc pour revenir à la solution form-data.
    // const handleFile = (selectedFile) => {
    //     resetDropzone();
    //     setImportSummary(null);
    //     setFile(selectedFile);
    //     setUploadDone(true);
    // };

    // ─── handleConfirmImport — envoi du filename uuid à /rcg/import ──────────
    const handleConfirmImport = async () => {
        setImporting(true);
        setImportError(null);
        try {
            const res = await ms.importRcg(filename);
            if (res && res.status >= 200 && res.status < 300) {
                resetDropzone();
                setImportSummary(res.data?.summary ?? {});
            } else {
                setImportError("Erreur lors de l'import. Veuillez réessayer.");
            }
        } catch {
            setImportError("Erreur lors de l'import. Veuillez réessayer.");
        } finally {
            setImporting(false);
            setShowModal(false);
        }
    };

    // ─── [FORM-DATA] handleConfirmImport — envoi du fichier en form-data ─────
    // Remplacer le bloc ci-dessus par ce bloc pour revenir à la solution form-data.
    // const handleConfirmImport = async () => {
    //     setImporting(true);
    //     setImportError(null);
    //     try {
    //         const res = await ms.importRcgFile(file);
    //         if (res && res.status >= 200 && res.status < 300) {
    //             resetDropzone();
    //             setImportSummary(res.data?.summary ?? {});
    //         } else {
    //             setImportError("Erreur lors de l'import. Veuillez réessayer.");
    //         }
    //     } catch {
    //         setImportError("Erreur lors de l'import. Veuillez réessayer.");
    //     } finally {
    //         setImporting(false);
    //         setShowModal(false);
    //     }
    // };

    return (
        <div className="panel-card">
            {importSummary && <ImportSummary summary={importSummary} />}

            <FileDropzone
                accept={ACCEPTED_EXTENSIONS}
                maxSizeMb={MAX_SIZE_MB}
                onFile={handleFile}
                file={file}
                uploading={uploading}
                uploadDone={uploadDone}
                uploadError={uploadError}
            />

            {importError && (
                <p className="form-feedback form-feedback--error">
                    <i className="fas fa-exclamation-circle" /> {importError}
                </p>
            )}

            <button
                className="btn-full-green"
                disabled={!uploadDone || importing}
                onClick={() => setShowModal(true)}
                style={{ marginTop: 16 }}
            >
                <i className="fas fa-check" /> Valider l'import
            </button>

            {showModal && (
                <div className="modal-d">
                    <div className="wrapper-modal">
                        <div className="modal-content small-modal b-btns">
                            <div className="header-modal">
                                <i className="fas fa-file-import" /> Confirmer l'import
                            </div>
                            <div className="content-modal">
                                <p>
                                    Êtes-vous sûr de vouloir lancer l'import des données du fichier{' '}
                                    <strong>{file?.name}</strong> ?
                                </p>
                            </div>
                            <div className="footer-modal">
                                <button
                                    className="btn btn-grey"
                                    onClick={() => setShowModal(false)}
                                    disabled={importing}
                                >
                                    Annuler
                                </button>
                                <button
                                    className="btn btn-blue"
                                    onClick={handleConfirmImport}
                                    disabled={importing}
                                >
                                    {importing
                                        ? <><i className="fas fa-spinner fa-spin" /> Import…</>
                                        : 'Confirmer'
                                    }
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export { ImportActionsCard };
